export const VEHICLE_LIST_ANALYTICS_NAMES = {
    searchPage: 'searchresult',
    magazine: 'magazine',
    related: 'pdp_similar',
    favorites: 'wishlist',
    homepage: 'homepage',
};
